<script>
    import { onMount, onDestroy } from 'svelte';
    import { datepickerRange, getDateRangeFromPreset, resetFlatpickrDate } from '@lib/datepicker/datepickerRange';  
    import { datePresetOptions } from '@lib/models/datePresetOptions'
    import { perPageOptions } from '@lib/models/perPageOptions'
    import ItemPerPageSelect from '@components/ItemPerPageSelect.svelte';
    import { formatDateToKorean } from '@lib/util/dateUtils';
    import Pagination from '@components/Pagination.svelte';
    import { getUser } from '@lib/api/user';
    import { getPlan } from '@lib/api/plan';
    import PointChargePopup from '@components/PointChargePopup.svelte';

    let isInitialMount = true;          // 초기 mount 여부 확인
    let isCategoryOpen = false;         // 검색 조건 카테고리 선택 드롭다운 열림 여부
    let isPlanCategoryOpen = false;     // 결제플랜 카테고리 선택 드롭다운 열림 여부
    let isDatePresetOpen = false;       // 날짜 프리셋 선택 드롭다운 열림 여부
    let isItemsPerPageOpen = false;     // 테이블 조회 개수 선택 드롭다운 열림 여부

    let viewCategory = '';              // 사용자에게 표시할 카테고리명 (ex. 상태, 제목 등)
    let viewPlanCategory = '';              // 사용자에게 표시할 결제플랜 카테고리명 (ex. 상태, 제목 등)
    let viewDataPreset = '';            // 사용자에게 표시할 날짜 프리셋명 (ex. 오늘, 어제 등)
    let viewItemsPerPage = '';          // 사용자에게 표시할 테이블 조회 개수

    let categoryDropdownEl = null;      // 카테고리 드롭다운 DOM 요소 참조
    let planCategoryDropdownEl = null;  // 결제플랜 카테고리 드롭다운 DOM 요소 참조
    let datePresetDropdownEl = null;    // 날짜 프리셋 드롭다운 DOM 요소 참조
    let viewCountDropdownEl = null;     // 테이블 조회 개수 드롭다운 DOM 요소 참조

    let error = '';                     // 에러 메시지 (빈 문자열이면 에러 없음)

    let loading = true;                 // 사용자 데이터 로딩 상태

    let users = [];                      // API에서 받아온 사용자 목록
    let total = 0;                      // 전체 개수
    let size = 20;                      // 페이지당 공지사항 수 (기본: 20)
    
    let totalPages = 0; 
    let currentPage = 1;

    // 포인트 충전 팝업 상태
    let isChargeOpen = false;
    let chargeTarget = null;

    let startRef = {                    // 시작 날짜 input에 바인딩된 flatpickr 인스턴스 조작용 객체
        onStartChange: (dateStr) => {
            searchParam.startDate = dateStr;
        }
    };

    let endRef = {                      // 종료 날짜 input에 바인딩된 flatpickr 인스턴스 조작용 객체
        onEndChange: (dateStr) => {
            searchParam.endDate = dateStr;
        }
    };
     
    const filterOptions = [
        { label: '사용자 ID', value: 'kakao_id' },
        { label: '사용자 이름',    value: 'nickname' },
        { label: '결제플랜', value: 'plan_id' },
        { label: '추천인 ID', value: 'recommend_id' }
    ];

    let planFilterOptions = [];

    const defaultSearchParam = {
        category: "",
        searchKeyword: "",
        plan_id: "",
        startDate: "",
        endDate: "",
        status: "",
        page: 1,
        size: size
    };

    let searchParam = { ...defaultSearchParam }; // 초기값 세팅

    /**
     * 사용자 목록을 API로부터 불러와 `users` 배열에 저장합니다.
     *
     * - `getUser` API를 호출하여 검색 조건(`searchParam`)에 따른 사용자 데이터를 가져옵니다.
     * - 응답 결과에서 전체 사용자 수(`total`)와 사용자 리스트(`items`)를 추출합니다.
     * - 페이지네이션을 위해 `totalPages` 값을 계산합니다.
     * - API 호출 도중 에러가 발생하면 콘솔에 로그를 출력하고, 사용자에게 에러 메시지를 표시합니다.
     * - 함수 실행 전후로 `loading` 상태를 적절히 설정하여 로딩 인디케이터를 제어합니다.
     *
     * @async
     * @function fetchUsers
     * @param {Object} searchParam - 사용자 검색 조건 (예: page, size, filters 등)
     * @returns {Promise<void>}
     */
    async function fetchUsers(searchParam) {
        loading = true;
        try {
            const data = await getUser(searchParam);
            total = data.total;
            users = data.items;

            console.log(users);
            console.log(total);
            totalPages = Math.ceil(total / searchParam.size);
            
        } catch (err) {
            console.error('사용자 정보 불러오기 실패:', err);
            error = '사용자 정보를 불러오지 못했습니다.';
        } finally {
            loading = false;
        }
    }

    /**
     * 플랜 목록을 API로부터 불러와 `plans` 배열에 저장합니다.
     *
     * - `getPlan` API를 호출하여 페이징된 데이터를 받아옵니다.
     * - 각 플랜의 단위(currency, period)를 사람이 읽을 수 있는 텍스트로 변환합니다.
     * - 변환된 텍스트는 `unit` 필드로 추가되어 템플릿에서 사용됩니다.
     * - 로딩 상태와 에러 메시지를 상태 변수로 관리합니다.
     *
     * @async
     * @function fetchPlans
     * @returns {Promise<void>}
     */
    async function fetchPlans() {
        loading = true;
        try {
            const data = await getPlan({});
            
            planFilterOptions = data.items;


        } catch (err) {
            console.error('플랜 불러오기 실패:', err);
            error = '플랜 정보를 불러오지 못했습니다.';
        } finally {
            loading = false;
        }
    }
    /**
     * 날짜 프리셋(오늘, 어제, 이번 주 등)을 선택했을 때 실행되는 핸들러
     *
     * 1. 프리셋에 맞는 날짜 범위 계산
     * 2. UI 및 내부 상태 업데이트 (viewDataPreset, searchParam 등)
     * 3. flatpickr 인스턴스를 통해 실제 input 요소의 날짜 갱신
     *
     * @param {{ label: string, value: string }} datePresetOptions - 선택된 날짜 프리셋 옵션 객체
     */
    async function selectDatePreset(datePresetOptions) {
        const result = getDateRangeFromPreset(datePresetOptions.value);
       
        if (!result) return;


        viewDataPreset = datePresetOptions.label;
        searchParam.startDate = result.startDate;
        searchParam.endDate = result.endDate;
        isDatePresetOpen = false;


        // Date 객체로 변환
        const start = new Date(result.startDate);
        const end = new Date(result.endDate);

        resetFlatpickrDate(startRef.instance, start);
        resetFlatpickrDate(endRef.instance, end);

    }

    function searchBoxReset(){
        // searchParam 초기화
        searchParam = { ...defaultSearchParam };

        // UI 관련 리셋 로직 실행
        selectCategory(filterOptions[0]);
        selectDatePreset(datePresetOptions[0]);
        selectPlanCategory(planFilterOptions[0]);

    }

    function search(){
        console.log(searchParam);
        fetchUsers(searchParam);
    }

    // 검색 조건 카테고리 드롭다운 열기/닫기 토글
    function toggleCategoryDropdown() {
        isCategoryOpen = !isCategoryOpen;
    }

    // 결제플랜 조건 카테고리 드롭다운 열기/닫기 토글
    function togglePlanCategoryDropdown() {
        isPlanCategoryOpen = !isPlanCategoryOpen;
    }

    function toggleItemsPerPageDropdown() {
        isItemsPerPageOpen = !isItemsPerPageOpen;
    }

    // 날짜 프리셋(오늘/이번주 등) 드롭다운 열기/닫기 토글
    function toggleDataPresetDropdown() {
        isDatePresetOpen = !isDatePresetOpen;
    }

    /**
     * 카테고리 선택 시 호출됨
     * @param {{ label: any; value: any; }} filterOptions
     */
    function selectCategory(filterOptions) {
        viewCategory = filterOptions.label;
        searchParam.category = filterOptions.value;
        isCategoryOpen = false; // 선택 후 드롭다운 닫기
    }

    /**
     * 결제플랜 카테고리 선택 시 호출됨
     * @param {{ plan_name: any; _id: any; }} planFilterOptions
     */
    function selectPlanCategory(planFilterOptions) {
        viewPlanCategory = planFilterOptions.plan_name;
        searchParam.plan_id = planFilterOptions._id;
        isPlanCategoryOpen = false; // 선택 후 드롭다운 닫기
    }
    /**
     * 드롭다운 외부 클릭 시 드롭다운을 닫기 위한 이벤트 핸들러
     * @param {{ target: any; }} event 클릭 이벤트 객체
     */
    function handleClickOutside(event) {
        // 카테고리 드롭다운 외부 클릭 감지
        if (isCategoryOpen && categoryDropdownEl && !categoryDropdownEl.contains(event.target)) {
            isCategoryOpen = false;
        }

        // 결제플랜 카테고리 드롭다운 외부 클릭 감지
        if (isPlanCategoryOpen && planCategoryDropdownEl && !planCategoryDropdownEl.contains(event.target)) {
            isPlanCategoryOpen = false;
        }   

        if (isDatePresetOpen && datePresetDropdownEl && !datePresetDropdownEl.contains(event.target)) {
            isDatePresetOpen = false;
        }
    }

    /**
     * @param {object} viewCountObject
     */
    function selectItemsPerPage(viewCountObject) {
        viewItemsPerPage = viewCountObject.label;
        size = viewCountObject.value;
        searchParam.size = viewCountObject.value;
        searchParam.page = 1;
        isItemsPerPageOpen = false;

        // 초기 mount일 때는 호출하지 않음
        if (!isInitialMount) {
            fetchUsers(searchParam);
        }

    }

    function handleSelect(option) {
        selectItemsPerPage(option);
    }

    /**
     * @param {number} page
     */
    function handlePageChange(page) {
        currentPage = page;
        searchParam.page = page;
        fetchUsers(searchParam);
    }
    /* 포인트 충전 팝업 관련 */
    function openCharge(user) {
        chargeTarget = user;
        isChargeOpen = true;
    }
    function closeCharge() {
        isChargeOpen = false;
        chargeTarget = null;
    }
    async function afterCharged() {
        // 충전 완료 후 리스트 갱신
        await fetchUsers(searchParam);
    }
    onMount(async () => {
        document.addEventListener('click', handleClickOutside);
        
        
        selectCategory(filterOptions[0]);
        selectDatePreset(datePresetOptions[0]);
        selectItemsPerPage(perPageOptions[0]);

        //결제플랜 불러오고나서 세팅 해야함
        await fetchPlans();

        if (planFilterOptions.length > 0) {
            selectPlanCategory(planFilterOptions[0]);
        }

        fetchUsers(searchParam);

        isInitialMount = false; // 초기호출 수행 시 false로 반환
    });

    onDestroy(() => {
        document.removeEventListener('click', handleClickOutside);
    });
</script>
 <div class="userMng-wrap d-flex flex-column h-100">
    <p class="font-20 font-weight-700">사용자 관리</p>
    <section class="box-gray d-flex align-center mt-5">
        <article class="form-block">
            <form action="" class="d-flex align-center flex-wrap gap-3">
                <fieldset class="width-160">
                    <legend>사용자 관리 input 셀렉트</legend>
                    <div class="custom-select w-100" class:active={isCategoryOpen} bind:this={categoryDropdownEl}>
                         <button type="button" class="custom-select__selected" on:click={toggleCategoryDropdown}>
                            <span>{viewCategory}</span>
                            <i class="icon icon-dropdown"></i>
                        </button>
                        <ul class="custom-select__options">
                            {#each filterOptions as option}
                            <li class="custom-select__option">
                                <button
                                    type="button"
                                    class="custom-select__button"
                                    on:click={() => selectCategory(option)}
                                    >
                                    {option.label}
                                </button>
                            </li>
                            {/each}
                        </ul>
                    </div>
                </fieldset>
                <fieldset class="width-200">
                    <legend>사용자 관리 input 텍스트</legend>
                    <label for="input-field-userMng">
                        <input 
                            type="text" 
                            name="" 
                            id="input-field-userMng" 
                            class="input-field" 
                            title="userMng input 텍스트" 
                            placeholder="" 
                            bind:value={searchParam.searchKeyword}
                                on:keydown={(e) => {
                                    if (e.key === 'Enter') {
                                    e.preventDefault();
                                    search();
                                    }
                                }}
                        >
                    </label>
                </fieldset>

            </form>
        </article>
        <article class="form-block ml-12">
            <p class="form-block__title">기간 검색</p>
            <form action="" class="d-flex align-center ml-5 gap-3">
                <fieldset>
                <legend>input style default input 달력</legend>
                <div class="d-flex align-center flex-row js-datepicker-range height-40">
                    <div class="ui-form-block h-100">
                        <input
                        type="text"
                        class="input-field h-100 js-datepicker-range__min"
                        title="시작 날짜"
                        use:datepickerRange={{ type: 'start', ref: startRef }}
                        />
                    </div>
                    <span class="el-hyphen d-flex align-center mx-3">~</span>
                    <div class="ui-form-block h-100">
                        <input
                        type="text"
                        class="input-field h-100 js-datepicker-range__max"
                        title="종료 날짜"
                        use:datepickerRange={{ type: 'end', ref: endRef }}
                        />
                    </div>
                </div>

            </fieldset>
                <fieldset class="width-80">
                   <legend>요일 input 셀렉트</legend>
                    <div class="custom-select w-100" class:active={isDatePresetOpen} bind:this={datePresetDropdownEl}>
                         <button type="button" class="custom-select__selected" on:click={toggleDataPresetDropdown}>
                            <span>{viewDataPreset}</span>
                            <i class="icon icon-dropdown"></i>
                        </button>
                        <ul class="custom-select__options">
                            {#each datePresetOptions as option}
                            <li class="custom-select__option">
                                <button
                                    type="button"
                                    class="custom-select__button"
                                    on:click={() => selectDatePreset(option)}
                                    >
                                    {option.label}
                                </button>
                            </li>
                            {/each}
                        </ul>
                    </div>
                </fieldset>
            </form>
        </article>
        <article class="form-block ml-12">
            <p class="form-block__title">결제플랜</p>
            <form action="" class="d-flex align-center flex-wrap gap-3 ml-5">
                <fieldset class="width-160">
                    <legend>결제플랜 input 셀렉트</legend>
                    <div class="custom-select w-100"  class:active={isPlanCategoryOpen} bind:this={planCategoryDropdownEl}>
                        <button type="button" class="custom-select__selected" on:click={togglePlanCategoryDropdown}>
                            <span>{viewPlanCategory}</span>
                            <i class="icon icon-dropdown"></i>
                        </button>
                        <ul class="custom-select__options">
                            {#each planFilterOptions as option}
                            <li class="custom-select__option">
                                <button
                                    type="button"
                                    class="custom-select__button"
                                    on:click={() => selectPlanCategory(option)}
                                    >
                                    {option.plan_name}
                                </button>
                            </li>
                            {/each}
                        </ul>
                    </div>
                </fieldset>
            </form>
        </article>
        <article class="form-block ml-auto">
            <button type="button" class="btn btn-reset" aria-label="reset" on:click={searchBoxReset}>
                <i class="icon icon-reset"></i>
            </button>
            <button type="button" class="btn bg-darkgray height-40 ml-1" on:click={search}>조회</button>
        </article>
    </section>
    <div class="d-flex align-center mt-5">
        <p class="table-count">
            총 <span>{total}</span> 건
        </p>
        <form action="" class="d-flex align-center flex-wrap gap-3 ml-auto">
            <fieldset class="width-120">
                <legend>사용자 관리 테이블 개수 input 셀렉트</legend>
                <div class="custom-select w-100"  class:active={isItemsPerPageOpen} bind:this={viewCountDropdownEl}>
                    <button type="button" class="custom-select__selected" on:click={toggleItemsPerPageDropdown}>
                        <span>{viewItemsPerPage}</span>
                        <i class="icon icon-dropdown"></i>
                    </button>
                     <ItemPerPageSelect options={perPageOptions} onSelect={handleSelect} />
                </div>
            </fieldset>
        </form>
    </div>
    <div class="d-flex flex-column h-100 mt-2 bg-white box-border">
        <div class="table-wrap">
            <table class="table-basic table-basic-userMng">
                <caption></caption>
                <colgroup>
                    <col style="width:5%">
                    <col style="width:auto">
                    <col style="width:15%">
                    <col style="width:15%">
                    <col style="width:15%">
                    <col style="width:15%">
                    <col style="width:15%">
                    <col style="width:10%">
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">번호</th>
                        <th scope="col">사용자 ID</th>
                        <th scope="col">사용자 이름</th>
                        <th scope="col">잔여 포인트</th>
                        <th scope="col">결제플랜</th>
                        <th scope="col">추천인 ID</th>
                        <th scope="col">가입일시</th>
                        <th scope="col">최근 결제일시</th>
                        <th scope="col">액션</th>
                    </tr>
                </thead>
                <tbody>
                {#if loading}
                    <tr>
                    <td colspan="6" class="text-center">로딩 중...</td>
                    </tr>
                {:else if error}
                    <tr>
                    <td colspan="6" class="text-center text-red">{error}</td>
                    </tr>
                {:else if users.length === 0}
                    <tr>
                    <td colspan="6" class="text-center">등록된 플랜이 없습니다.</td>
                    </tr>
                {:else}
                    {#each users as user, index}
                    <tr>
                        <td>{index+1}</td>
                        <td>{user.kakao_id}</td>
                        <td>{user.nickname}</td>
                        <td>{user.point}</td>
                        <td>{user.plan_name}</td>
                        <td>{user.recommend_id}</td>
                        <td>{formatDateToKorean(user.created_at)}</td>
                        <td>{formatDateToKorean(user.created_at)}</td>
                        <td>
                            <button type="button" class="btn bg-blue" on:click={() => openCharge(user)}>
                                충전
                            </button>
                        </td>
                    </tr>
                    {/each}
                {/if}
                </tbody>
            </table>
        </div>
    </div>
    <Pagination {currentPage} {totalPages}  pageChange={handlePageChange}></Pagination>
    {#if isChargeOpen}
    <PointChargePopup
        onClose={closeCharge}
        onSave={afterCharged}
        user={chargeTarget}
    />
    {/if}
</div>